<script setup>
  import { ref } from "vue";

  const props = defineProps({
    categories: {
      type: Array,
      default: () => []
    },
    sortFilters: {
      type: Object,
      default: null,
    }
  });

  const emit = defineEmits(["filter-updated"]);

  const loading = ref(false);
  const openGroups = ref({});

  const trans = (key) => typeof _ !== 'undefined' ? _.get(window.translations, key, key) : key;

  const toggleGroup = (id) => {
    openGroups.value[id] = !openGroups.value[id];
  };

  const navigateToFilter = (link) => {
    if (!link) return;

    try {
      const targetUrl = new URL(link, window.location.origin);
      const currentParams = new URLSearchParams(window.location.search);
      const paramsToPreserve = ["perPage", "perRow", "name", "mostRecent"];
      paramsToPreserve.forEach(param => {
        if (currentParams.has(param)) {
          targetUrl.searchParams.set(param, currentParams.get(param));
        }
      });

      emit("filter-updated", targetUrl.pathname + targetUrl.search);
    } catch (e) {
      emit("filter-updated", link);
    }
  };

  const hasChildren = (item) => {
    return !!(item.childs && item.childs.length);
  };

  const getChildren = (item) => {
    return item.childs || [];
  };

  const handleCategoryClick = (category) => {
    if (hasChildren(category)) {
      toggleGroup(category.id);
    } else {
      navigateToFilter(category.link || category.slug);
    }
  };
</script>

<template>
  <div class="filters-sidebar-pure">
    <div v-if="loading" class="loading">
      {{ trans("Loading files") }}
    </div>
    <template v-else>
      <ul class="category-list">
        <li
          v-for="category in categories"
          :key="category.id"
          class="category-item">
          <div class="group-header">
            <button
              type="button"
              class="group-title"
              @click="handleCategoryClick(category)">
              {{ category.label }}
            </button>
            <button
              v-if="hasChildren(category)"
              type="button"
              class="arrow-trigger"
              :class="{ rotated: openGroups[category.id] }"
              @click="toggleGroup(category.id)"
              aria-label="Abrir submenu">
              <svg xmlns="http://www.w3.org/2000/svg"
                   width="16"
                   height="16"
                   viewBox="0 0 24 24"
                   fill="none"
                   stroke="currentColor"
                   stroke-width="2.5"
                   stroke-linecap="round"
                   stroke-linejoin="round"
                   class="chevron-icon">
                <path d="m6 9 6 6 6-6"/>
              </svg>
            </button>
          </div>
          <ul
            v-if="hasChildren(category) && openGroups[category.id]"
            class="children">
            <li
              v-for="child in getChildren(category)"
              :key="child.id"
              class="category-item">
              <div class="group-header">
                <button
                  type="button"
                  class="group-title child"
                  @click="handleCategoryClick(child)">
                  {{ child.label }}
                </button>
                <button
                  v-if="hasChildren(child)"
                  type="button"
                  class="arrow-trigger"
                  :class="{ rotated: openGroups[child.id] }"
                  @click="toggleGroup(child.id)"
                  aria-label="Abrir submenu">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       width="14"
                       height="14"
                       viewBox="0 0 24 24"
                       fill="none"
                       stroke="currentColor"
                       stroke-width="2.5"
                       stroke-linecap="round"
                       stroke-linejoin="round"
                       class="chevron-icon">
                    <path d="m6 9 6 6 6-6"/>
                  </svg>
                </button>
              </div>
              <ul
                v-if="hasChildren(child) && openGroups[child.id]"
                class="children final-level">
                <li
                  v-for="sub in getChildren(child)"
                  :key="sub.id">
                  <button
                    type="button"
                    class="filter-item-btn"
                    @click="navigateToFilter(sub.link || sub.slug)">
                    {{ sub.label }}
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </template>
  </div>
</template>

<style scoped>

</style>
